<template>
    <div id="custom_table">
        <div>
            <div class="toolbar_operations">
                <v-icon title="Filter" class="fa fa-filter12" small @click="isFilter()" aria-hidden="true"></v-icon>
                <v-icon title="Refresh" small @click="refreshClick()" class="fa fa-refresh fa-refresh1"></v-icon>
                <v-icon title="Upload Leads" small v-show="pagecontrol.fileupload" @click="UploadFile()"
                    class="fas fa-upload">
                </v-icon>
                <v-icon title="download Leads" small v-show="pagecontrol.export" @click="download_()"
                    class="fas fa-download1">
                </v-icon>
                <v-icon title="Create Leads" small v-show="pagecontrol.cancreate" @click="insertDetails()"
                    class="fas fa-plus1">
                </v-icon>
                <v-icon v-if="bulk_edit_arr.length > 0" title="Bulk Edit" small @click="editClick()"
                    class="fa fa-pencil-square-o"></v-icon>
                <div v-else></div>
                <v-icon v-if="bulk_edit_arr.length > 0" title="Bulk Delete" small @click="deleteClick()"
                    class="fas fa-trash-alt"></v-icon>
                <div v-else></div>
            </div>
            <div>

                <v-data-table :headers="headers" :items="AsterLeadValue" class="elevation-1" hide-default-header    
                    :headers-length=10 hide-actions>
                    <template v-slot:headers="props" id="table-scroll">
                        <tr style="height:30px">
                            <th style="height: 32px; width: 50px;">
                                <v-checkbox @change="select_all()" style="padding-top: 12px; padding-left: 2px;height:50px"
                                    v-model="select_check" color="primary">
                                </v-checkbox>
                            </th>
                            <th style="min-width:150px" v-for="( head, i) in props.headers" :key="i">
                                {{ head.text }}
                            </th>
                            <th style="text-align:center">Action</th>
                        </tr>
                    </template>
                    <template style="text-align:center" v-slot:items="props">
                        <tr v-if="AsterLeadValue.length > 0">
                            <td>
                                <v-checkbox v-model="props.item.checker" primary @change="newValue(props.item)" hide-details
                                    color="primary"></v-checkbox>
                            </td>

                            <td style="min-width:170px" class="checkEmpty"
                                v-for="(property, index) in Object.keys(props.item)" :key="index">
                                <p style="margin-top:14px;" v-if="property !== 'checker'">{{ props.item[property] == ""
                                    ||
                                    props.item[property] == null || props.item[property] == undefined ? "-" :
                                    props.item[property]
                                }}</p>
                                <div class="icon_section">
                                    <template v-if="property == 'checker'">
                                        <v-icon small class="mr-4" v-show="pagecontrol.canedit"
                                            @click="insertDetails('edit', props.item.lead_id)">
                                            info</v-icon>
                                        <v-icon color="blue" v-show="pagecontrol.userassign"
                                            @click="assignAgent(props.item)" title="Agent Assign" small class="mr-4">
                                            queue</v-icon>
                                        <v-icon color="red" small class="mr-4" title="Delete" v-show="pagecontrol.candelete"
                                            @click="deleteDetails(props.item)">delete
                                        </v-icon>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </div>
            <div class="pagination-div theme--light" style="height:50px">
                <div flex id="row-selector">
                    <div id="page-control">
                        <span>{{ (currentPage - 1) * perPage + 1 }}-{{ endPage }} of
                            {{ totalRows }}</span>
                        <span class="action-icon">
                            <v-icon medium class="move-page" @click="moveNextPage(false)">chevron_left</v-icon>
                            <v-icon medium class="move-page" @click="moveNextPage(true)">chevron_right</v-icon>
                        </span>
                    </div>
                </div>
            </div>

            <v-dialog persistent v-model="DeleteRowdata" max-width="500px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Delete Lead info</v-toolbar-title>
                    </v-toolbar>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-card-text>Are you sure to delete this lead ?</v-card-text>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="closedelete()">Cancel</v-btn>
                        <v-btn color="primary" @click="savedelete()">Yes, Delete !</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="isShowAgentAssign" scrollable max-width="400px">

                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>Assign Lead</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="refassign" v-model="valid">
                            <v-container id="scroll-target" style="max-height: 350px" class="scroll-y">
                                <template>
                                    <v-autocomplete v-model="assignedDetails.user" :items="agents" label="Agent" required
                                        persistent-hint :menu-props="{ allowOverflow: false }"></v-autocomplete>
                                </template>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="modal-footer--sticky">
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="closeAssign()">Cancel</v-btn>
                        <v-btn color="primary" @click="submitAssign()">Save</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
            <v-navigation-drawer fixed disable-resize-watcher right :value="pagecontrol.isFilterOpen">
                <v-toolbar small color="secondary" style="color: white">
                    <v-toolbar-title>Filter</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon flat color="white" @click="pagecontrol.isFilterOpen = false">
                        <i class="fas fa-close"></i>
                    </v-btn>
                </v-toolbar>
                <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
                    <v-container class="sidenavContainer">
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[0]" :key="indexfield">
                                <div class="autocompleteDiv">
                                    <v-text-field v-model="field.value" :label="field.text" small></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[1]" :key="indexfield">
                                <div class="autocompleteDiv" v-if="!field.isMultiSelect">
                                    <v-select :items="field.options" :label="field.text" v-model="field.value"
                                        item-text="name" item-value="value"></v-select>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[1]" :key="indexfield">
                                <div class="autocompleteDiv" v-if="field.isMultiSelect">
                                    <v-select :items="field.options" :label="field.text" v-model="field.value"
                                        item-text="name" item-value="value" multiple></v-select>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[2]" :key="indexfield">
                                <div class="autocompleteDiv">
                                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-combobox v-model="field.value" :label="field.text" v-bind="attrs" v-on="on">
                                            </v-combobox>
                                        </template>
                                        <v-date-picker v-model="field.value" color="primary" @input="menu = false"
                                            width="250" no-title scrollable>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[3]" :key="indexfield">
                                <!-- <div class="autocompleteDiv">
                                    <datetime class="theme-orange" color="primary"
                                        style="border-bottom: 1px solid rgb(145 145 145)" type="datetime"
                                        format="yyyy-MM-dd HH:mm:ss" v-model="field.value" :placeholder="field.text">
                                    </datetime>
                                </div> -->
                                {{ field.text }}
                                    <v-container class="pa-1">
                                        <v-menu v-model="pagecontrol.menu.fromdate" :close-on-content-click="false"
                                            label="Created At" full-width max-width="290" small>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field :value="appliedfilter.fromdate" label="From Date" readonly
                                                    v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="primary" v-model="appliedfilter.fromdate"
                                                @change="pagecontrol.menu.fromdate = false">
                                            </v-date-picker>                                        </v-menu>
                                    </v-container>

                                    <v-container class="pa-1">
                                        <v-menu v-model="pagecontrol.menu.todate" :close-on-content-click="false" full-width
                                            max-width="290" small>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field :value="appliedfilter.todate" label="To Date" readonly
                                                    v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="primary" v-model="appliedfilter.todate"
                                                @change="pagecontrol.menu.todate = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-container>


                                
                            </div>
                        </div>
                        <br />
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[4]" :key="indexfield">
                                <div class="autocompleteDiv">
                                    <v-checkbox v-model="field.value" :label="field.text" primary
                                        @change="newValue(props.item)" hide-details color="primary"></v-checkbox>
                                    <br /><br />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="(field, indexfield) in dynamicFilterField[5]" :key="indexfield">
                                <div class="autocompleteDiv">
                                    <p>{{ field.text }}</p>

                                    <v-radio-group v-model="field.value">
                                        <v-radio v-for="(n, indexn) in field.options" :key="indexn" :value="n"
                                            color="primary" :label="`${n.value}`">
                                        </v-radio>
                                    </v-radio-group>
                                </div>
                            </div>
                        </div>

                    </v-container>
                    <v-container row class="sidenavFooter">
                        <v-btn flat @click="reset()">Reset</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="fetchFilter()">Filter</v-btn>
                    </v-container>
                </div>
            </v-navigation-drawer>
            <template>
                <v-dialog persistent v-model="pagecontrol.isUploadFile" scrollable max-width="500px">
                    <v-card>

                        <!-- <v-toolbar dark color="primary"> -->
                        <v-toolbar dark color="primary">
                            <div class="pop_title">
                                <div>
                                    <div style="font-size:large;font-weight: 600;">Upload Leads </div>
                                </div>
                                <div style="padding-top: 3px;">
                                    <v-icon color="light" flat style="font-size:20px" @click="ColseFile()">
                                        fa-times</v-icon>
                                </div>
                            </div>
                        </v-toolbar>
                        <!-- <v-card-title>
    <span class="headline">Upload AsterLead</span>
    </v-card-title>
    </v-toolbar> -->
                        <v-card-text>
                            <v-form v-if="mapper === false" ref="createform">
                                <v-container grid-list-md>
                                    <div class="autocompleteDiv">
                                        <v-autocomplete v-model="selected_list" :items="add_list" label="List"
                                            persistent-hint small required single-line
                                            :menu-props="{ allowOverflow: false }"
                                            :rules="[(v) => !!v || 'list is required']"></v-autocomplete>
                                    </div>
                                    <p v-if="csvheader.length === 0">
                                        <span style="font-weight: bold">Not sure what to upload?</span>
                                        Click here to download the sample file. Format:
                                        <a @click="samplefiledownload('csv')">CSV</a>,
                                        <a @click="samplefiledownload('txt')">Txt(Tab-Delimited)</a>.
                                        Open the file and enter the phone numbers at the first column of
                                        each row. Save the file with .csv /.txt extension and upload the
                                        file.
                                    </p>
                                    <div v-if="csvheader.length === 0" class="file-dummy" @click="$refs.file.click()"
                                        :style="{
                                            background: uploadLead.color + '66',
                                            'border-color': uploadLead.color,
                                            color: uploadLead.color,
                                        }">
                                        {{ uploadLead.label }}
                                    </div>
                                    <input v-if="csvheader.length === 0" v-on:change="filenext__()" :hidden="true"
                                        type="file" id="file" ref="file" accept=".csv,.txt" />
                                </v-container>
                            </v-form>
                            <div v-if="mapper === true && csvheader.length > 0">

                                <div class="map_value" v-for="(data, index_) in csvheader" :key="index_">
                                    <div class="map_value_lft">
                                        {{ index_ + 1 }}) {{ data.key }}
                                    </div>
                                    <v-autocomplete @change="assignedval(data)" v-model="data.value" :items="fields_model"
                                        item-text="name" item-value="value" item-disabled="active"></v-autocomplete>
                                </div>
                            </div>
                            <div v-if="mapper === false && selected_list !== '' && csvheader.length > 0" class="nextbutton">
                                <div @click="next__()" class="nextbutton-innerdiv">Next</div>
                            </div>
                            <div v-if="mapper" class="nextbutton">
                                <div @click="handleFileUpload()" class="nextbutton-innerdiv">Upload</div>
                            </div>

                        </v-card-text>
                        <!-- <v-card-actions class="model-footer--sticky">
    <v-spacer></v-spacer>
    <v-btn color="light" flat @click="ColseFile()">Cancel</v-btn>
    </v-card-actions> -->

                    </v-card>
                </v-dialog>
            </template>
            <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
                {{ snackbar.text }}
                <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
            </v-snackbar>
        </div>
        <template>
            <v-dialog persistent v-model="edit_popup" scrollable max-width="400px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-card-title>
                            <span class="headline">Update Leads</span>
                        </v-card-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <template>
                                        <v-select v-model="bulk_edit.user" :items="agents" label="User" required
                                            persistent-hint :menu-props="{ allowOverflow: false }"></v-select>
                                    </template>

                                </v-flex>
                                <v-flex xs12>
                                    <v-select label="Disposition" :items="bulk_dispo" return-string
                                        v-model="bulk_edit.disposition" persistent-hint></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select label="List ID" :items="add_list" v-model="bulk_edit.list_id" persistent-hint>
                                    </v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="modal-footer--sticky">
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="edit_popup = false">Cancel</v-btn>
                        <v-btn color="primary" @click="bulk_save">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <v-dialog persistent v-model="delete_popup" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Delete Lead Info</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-card-text>Are you sure to delete this leads ?</v-card-text>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="light" flat @click="delete_popup = false">Cancel</v-btn>
                    <v-btn color="primary" @click="bulkDelete">Yes, Delete !</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog persistent v-model="DownloadFile111" scrollable max-width="470px">
            <v-card>
                <v-toolbar dark color="primary">
                    <div class="pop_title">
                        <div>
                            <div style="font-size:large;font-weight: 600;">Download Leads </div>
                        </div>
                        <div style="padding-top: 3px;">
                            <v-icon color="light" flat style="font-size:20px" @click="closedownload">fa-times</v-icon>
                        </div>
                    </div>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <div>

                            <div class="exportflex">
                                <div class="export" @click="filedownload('csv')">

                                    <v-icon class="hovericon" size="60">fa fa-file-code-o
                                    </v-icon>
                                    <div style="font-size:20px;color:#2C3E50;font-weight:800;padding:5px">CSV </div>
                                </div>
                                <div class="export" @click="filedownload('txt')">
                                    <v-icon class="hovericon" size="60">fa-file-text
                                    </v-icon>
                                    <div style="font-size:20px;color:#2C3E50;font-weight:800;padding:5px">TXT</div>
                                </div>
                            </div>

                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="model-footer--sticky">
                    <v-spacer></v-spacer>
                    <!-- <v-icon color="light" flat size="35" @click="closedownload">fa-window-close-o</v-icon> -->

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
   
<script>
import moment from "moment";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import {
    mapGetters
} from "vuex";
import api from "@/utils/axios-util";
// import moment from "moment";
const {
    convertArrayToCSV
} = require("convert-array-to-csv");

function getDefaultData() {
    return {
        label: "Please select some files",
        color: "#2196f3",
    };
}
export default {
    name: "App",
    data() {
        return {
            mapper: false,
            headers: [],
            menu: false,
            selected_list: "",
            add_list: [],
            perPage: 8,
            currentPage: 1,
            totalRows: 0,
            endPage: 0,
            template_name: '',
            pagecontrol: {
                title: "User Management",
                icon: "fa-user",
                loading: true,
                isFilterOpen: false,
                isAddUser: false,
                isUploadFile: false,
                exportOptions: [],
                options: {
                    filter: false,
                    refresh: true
                },
                addnew: [],
                canedit: false,
                candelete: false,
                fileupload: false,
                export: false,
                cancreate: false,
                userassign: false,
                menu: {
                    fromdate: false,
                    todate: false,
                },
            },
            snackbar: {
                show: false,
                timeout: 6000,
                text: "",
            },
            AsterLeadValue: [],
            AsterLeadValueClone: [],
            bulk_edit_arr: [],
            bulk_edit: {
                user: "",
                disposition: "",
                list_id: "",
            },
            appliedfilter: {
                fromdate: "",
                todate: "",

            },
            bulk_dispo: [],
            select_label: "Select All",
            select_check: false,
            edit_popup: false,
            delete_popup: false,
            lead_history: [],
            // show_history: false,
            newData: [],
            fields: [],
            fielddata: [],
            DownloadFile111: false,
            DeleteRowdata: false,
            uploadLead: {},
            excel_data: [],
            read_data: "",
            from_date: "",
            to_date: "",
            isShowAgentAssign: false,
            assignedDetails: {},
            agents: [],
            valid: true,
            isfilterval: false,
            filter: {
                phone_number: "",
                list_id: "",
            },
            filtervalue: [],
            pagination: {},
            downloadData: [],
            dynamicFilterField: [],
            fieldtype: {
                DatetimePicker: [],
                DatePicker: []
            },
            csvheader: [],
            fields_model: []
        };
    },
    props: {
        titleDatas: {
            type: String,
            default: ""
        },
        // dynamicFilterField: {
        //     type: Array,
        // },

    },
    watch: {
        
        titleDatas() {
            this.headers = [];
            this.getDatafieldApi()
        },
        "appliedfilter.fromdate"(newVal) {
            var from_date = moment(newVal).format("YYYY-MM-DD");
            this.$store.commit("ACTION_FROMDATE", from_date);
            this.$store.commit("FILTERFROMDATE", from_date);
            this.skip = 0;

            // this.getDataFromApi();
        },
        "appliedfilter.todate"(newVal) {
            var to_date = moment(newVal).format("YYYY-MM-DD");
            this.$store.commit("ACTION_TODATE", to_date);
            this.$store.commit("FILTER_TODATE", to_date);
            this.skip = 0;
            // this.getDataFromApi();
        },
    },
    computed: {

        ...mapGetters(["GetAsterLead"]),

        sortOptions() {

            return this.newData
                .filter((f) => f.sortable)
                .map((f) => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
    },
    methods: {
        assignedval(data) {
            console.log(data, "hjdcjhcsajhcsahcvhjsacvhscvjhscvhjascv")
            for (let i = 0; i < this.fields_model.length; i++) {
                const element = this.fields_model[i];
                if (data.value === element.name) {
                    element.active = true
                }

            }

        },
        datetimeformate(data) {
            let datetime = new Date(data)
            let dd = datetime.getDate() < 10 ? `0${datetime.getDate()}` : datetime.getDate()
            let mm = datetime.getMonth() + 1 < 10 ? `0${datetime.getMonth() + 1}` : datetime.getMonth() + 1
            let hr = datetime.getHours() < 10 ? `0${datetime.getHours()}` : datetime.getHours()
            let min = datetime.getMinutes() < 10 ? `0${datetime.getMinutes()}` : datetime.getMinutes()
            return datetime.getFullYear() + `-${mm}-${dd} ${hr}:${min}`
        },
        dateformate(data) {
            let datetime = new Date(data)
            let dd = datetime.getDate() < 10 ? `0${datetime.getDate()}` : datetime.getDate()
            let mm = datetime.getMonth() + 1 < 10 ? `0${datetime.getMonth() + 1}` : datetime.getMonth() + 1
            return datetime.getFullYear() + `-${mm}-${dd}`
        },
        filedownload(value) {
            if (value == 'csv') {
                let csv = ''
                for (let row = 0; row < this.downloadData.length; row++) {
                    delete this.downloadData[row].modified_date
                    delete this.downloadData[row].hopper_status
                    delete this.downloadData[row].deleted
                    delete this.downloadData[row].isclosed
                    let keysAmount = Object.keys(this.downloadData[row]).length
                    let keysCounter = 0
                    if (row === 0) {
                        for (let key in this.downloadData[row]) {

                            csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n')

                            keysCounter++
                        } keysCounter = 0;
                        for (let key in this.downloadData[row]) {
                            if (this.fieldtype.DatetimePicker.includes(key) && this.downloadData[row][key] !== "") {
                                this.downloadData[row][key] = this.datetimeformate(this.downloadData[row][key])
                            }

                            if (this.fieldtype.DatePicker.includes(key) && this.downloadData[row][key] !== "") {
                                this.downloadData[row][key] = this.dateformate(this.downloadData[row][key])
                            }
                            csv += this.downloadData[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                            keysCounter++
                        }
                    } else {

                        for (let key in this.downloadData[row]) {
                            if (this.fieldtype.DatetimePicker.includes(key) && this.downloadData[row][key] !== "") {
                                this.downloadData[row][key] = this.datetimeformate(this.downloadData[row][key])
                            }

                            if (this.fieldtype.DatePicker.includes(key) && this.downloadData[row][key] !== "") {
                                this.downloadData[row][key] = this.dateformate(this.downloadData[row][key])
                            }
                            csv += this.downloadData[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                            keysCounter++
                        }
                    }

                    keysCounter = 0
                }


                let link = document.createElement('a')
                link.id = 'download-csv'
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                link.setAttribute('download', `${this.template_name.templetname}.csv`);
                document.body.appendChild(link)
                link.click();
                this.DownloadFile111 = false;

            } else if
                (value == "txt") {

                let txtContent = "";
                for (const key in this.downloadData[0]) {
                    if (key !== "modified_date" && key !== "hopper_status" && key !== "deleted") {
                        let txt_tab = `${key} \t`;
                        txtContent += `${txt_tab}`;
                    }

                }
                let fldtype = this.fieldtype
                let datetimefun = (data) => this.datetimeformate(data)
                let datefun = (data) => this.dateformate(data)
                this.downloadData.forEach(function (rows) {
                    delete rows.modified_date
                    delete rows.hopper_status
                    delete rows.deleted

                    for (let key in rows) {
                        if (fldtype.DatetimePicker.includes(key) && rows[key] !== "") {
                            rows[key] = datetimefun(rows[key])
                        }
                        if (fldtype.DatePicker.includes(key) && rows[key] !== "") {
                            rows[key] = datefun(rows[key])
                        }
                    }
                    let data = Object.values(rows);
                    let row = data.join("\t");
                    txtContent += `\n ${row}` + "\r";
                });
                var encodedUri1 =
                    "data:text/plain;charset=utf-8,\uFEFF" +
                    encodeURIComponent(txtContent);

                var link1 = document.createElement("a");
                link1.setAttribute("href", encodedUri1);
                link1.setAttribute("download", `${this.template_name.templetname}.txt`);
                document.body.appendChild(link1);
                link1.click();
                this.showSnackBar("Download Successfully");
                this.DownloadFile111 = false;
            }

        },
        download_() {
            this.DownloadFile111 = true;
        },
        closedownload() {
            this.DownloadFile111 = false;
        },
        insertDetails(val, id) {
            var scope = this;
            if (
                scope.$store.getters.UserPermissions.indexOf(
                    "leadmanagement:lead:create"
                ) === -1
            ) {
                scope.$router.push({
                    name: "blankPage",
                });
            } else {
                console.log("alter");
                scope.$store
                    .dispatch("GetFormFields", this.GetAsterLead)
                    .then(() => {
                        (val == 'edit') ? this.$emit("customform_edit", id) : this.$emit("customform_insert")
                    })
                    .catch(function (error) {
                        scope.showSnackBar("error" + error);
                    });
            }
        },
        showSnackBar(message) {
            let scope = this;
            scope.snackbar.text = message;
            scope.snackbar.show = true;
            setTimeout(() => {
                scope.snackbar.text = "";
            }, scope.snackbar.timeout);
        },
        newValue(row) {
            var scope = this;
            let id = row["lead_id"];
            if (!scope.bulk_edit_arr.includes(id)) {
                scope.bulk_edit_arr.push(id);
            } else {
                const index = scope.bulk_edit_arr.indexOf(id);
                if (index > -1) {
                    scope.bulk_edit_arr.splice(index, 1);
                }
            }
            if (this.AsterLeadValue.length == this.bulk_edit_arr.length) {
                scope.select_label = "Unselect All";
                scope.select_check = true;
            } else {
                scope.select_label = "Select All";
                scope.select_check = false;
            }
        },
        editClick() {
            this.edit_popup = true;
        },
        deleteClick() {
            this.delete_popup = true;
        },
        bulk_save() {
            var scope = this;
            var edit_data = {
                disposition: scope.bulk_edit.disposition,
                user: scope.bulk_edit.user,
                list_id: scope.bulk_edit.list_id,
                bulk_id: scope.bulk_edit_arr,
                template_name: this.GetAsterLead,
                modified_by: JSON.parse(localStorage.apiInfo).user_email
            };
            scope.$store
                .dispatch("BulkEditSave", edit_data)
                .then(() => {
                    scope.edit_popup = false;
                    scope.bulk_edit.user = "";
                    scope.bulk_edit.list_id = "";
                    scope.bulk_edit.disposition = "";
                    scope.bulk_edit_arr = [];
                    scope.select_label = "Select All";
                    scope.select_check = false;
                    scope.showSnackBar("Lead Updated Successfully");
                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });
            scope.getDatafieldApi();
        },
        bulkDelete() {
            var scope = this;
            var delete_data = {
                bulk_id: scope.bulk_edit_arr,
                template_name: this.GetAsterLead,
                modified_by: JSON.parse(localStorage.apiInfo).user_email,
            };
            scope.$store
                .dispatch("BulkDeleteSave", delete_data)
                .then(() => {
                    scope.delete_popup = false;
                    scope.bulk_edit_arr = [];
                    scope.select_label = "Select All";
                    scope.select_check = false;
                    this.getDatafieldApi()
                    scope.showSnackBar("Lead Deleted Successfully");
                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });
            scope.refresh_fun();
        },
        refresh_fun() {
            this.getDatafieldApi()
            var scope = this;
            let stats = {
                list_name: "",
                list_campaign: "",
                list_status: "Y",
            };
            scope.$store.dispatch("FilterAsterList", stats).then((response) => {
                let data = response.data;
                let list = [];
                for (let i = 0; i < data.length; i++) {
                    list.push(data[i].list_id);
                }
                scope.add_list = list;
            });
            scope.agents = JSON.parse(localStorage.getItem("group_users"));
            setTimeout(
                function () {
                    if (
                        scope.$store.getters.UserPermissions.indexOf(
                            "leadmanagement:lead:fileupload"
                        ) !== -1
                    ) {
                        scope.pagecontrol.fileupload = true;
                    }
                    if (
                        scope.$store.getters.UserPermissions.indexOf(
                            "leadmanagement:lead:userassign"
                        ) !== -1
                    ) {
                        scope.pagecontrol.userassign = true;
                    }
                    if (
                        scope.$store.getters.UserPermissions.indexOf(
                            "leadmanagement:lead:edit"
                        ) !== -1
                    ) {
                        scope.pagecontrol.canedit = true;
                    }
                    if (
                        scope.$store.getters.UserPermissions.indexOf(
                            "leadmanagement:lead:create"
                        ) !== -1
                    ) {
                        scope.pagecontrol.cancreate = true;
                    }
                    if (
                        scope.$store.getters.UserPermissions.indexOf(
                            "leadmanagement:lead:delete"
                        ) !== -1
                    ) {
                        scope.pagecontrol.candelete = true;
                    }
                }.bind(scope),
                1
            );

            this.uploadLead = getDefaultData();
        },
        select_all() {
            var scope = this;
            let id = "";
            if (scope.select_check) {
                scope.select_label = "Unselect All";
                scope.bulk_edit_arr = [];
                for (let i = 0; i < scope.AsterLeadValue.length; i++) {
                    scope.AsterLeadValue[i].checker = true;
                    id = scope.AsterLeadValue[i]["lead_id"];
                    scope.bulk_edit_arr.push(id);
                }
            } else {
                for (let j = 0; j < scope.AsterLeadValue.length; j++) {
                    scope.AsterLeadValue[j].checker = false;
                }
                scope.bulk_edit_arr = [];
                scope.select_label = "Select All";
            }
        },
        editDetails(row) {
            row = this.AsterLeadValueClone.find(elm => elm.lead_id == row.lead_id)
            var scope = this;
            if (
                scope.$store.getters.UserPermissions.indexOf(
                    "leadmanagement:lead:edit"
                ) === -1
            ) {
                scope.$router.push({
                    name: "blankPage",
                });
            } else {
                scope.$store.dispatch("Editdata", row);
                scope.$store.dispatch("GetFormFields", this.GetAsterLead).then(() => {
                    scope.$router.push({
                        name: "crm/EditAsterLead",
                    });
                });
            }
        },
        deleteDetails(row) {
            row = this.AsterLeadValueClone.find(elm => elm.lead_id == row.lead_id)
            var scope = this;
            if (scope.pagecontrol.candelete) {
                this.DeleteRowdata = true;
            }
            let id_value = "";
            for (const [key, value] of Object.entries(row)) {
                if (
                    `${key}` === "order id" ||
                    `${key}` === "ticket id" ||
                    `${key}` === "lead_id"
                ) {
                    id_value = `${value}`;
                }
            }
            this.delete_id = id_value;
        },
        closedelete() {
            this.DeleteRowdata = false;
        },
        savedelete() {
            let scope = this;
            scope.isProcessing = true;
            let payload = {
                template_name: this.GetAsterLead,
                delete_id: this.delete_id,
                modified_by: JSON.parse(localStorage.apiInfo).user_email,
            };
            this.$store.dispatch("deleteAsterLead", payload).then((response) => {
                scope.isProcessing = false;
                if (response.statusCode == 200) {
                    scope.showSnackBar("Lead Deleted Successfully");
                    scope.getDatafieldApi();
                } else {
                    scope.showSnackBar("Error! Unable Delete Lead");
                }
            });
            this.closedelete();
            this.getDatafieldApi();
        },
        reset() {
            this.isfilterval = false

            this.dynamicFilterField.forEach((fie) => {
                fie.forEach((sub) => {
                    if (sub.value != "") {
                        sub.value = ""
                    }
                    else{
                        this.appliedfilter.fromdate = "";
                     this.appliedfilter.todate = "";
                    }
                })
            })
            if (this.isfilterval === false) {
                this.getDatafieldApi()
            }


        },
        getDatafieldApi() {
            if (this.isfilterval) {
                this.fetchFilter()
            } else {
                
                
                
                var scope = this;
                scope.tableLoading = true;
                scope.pagecontrol.isFilterOpen = false;
                scope.filter.list_id = "";
                scope.filter.phone_number = "";
                scope.template_name = JSON.parse(localStorage.getItem("templetname"));
                const titleData_local = JSON.parse(localStorage.getItem("templetname"));
                let titleData = titleData_local.templetname;
                let AsterLeadFields = "";
                scope.bulk_edit.user = "";
                scope.bulk_edit.list_id = "";
                scope.bulk_edit.disposition = "";
                scope.bulk_edit_arr = [];
                scope.select_label = "Select All";
                scope.select_check = false;

                let checkboxes = [];
                let radio = [];
                let date_time = [];
                let date = [];
                let text = [];
                let select = [];

                this.$store
                    .dispatch("GetAsterLeadField", titleData)
                    .then((response) => {
                        var datas = response.data[0].fields;
                        AsterLeadFields = datas;

                        if (scope.headers.length === 0) {
                            this.dynamicFilterField = [];
                            for (let i = 0; AsterLeadFields.length > i; ++i) {
                                if (AsterLeadFields[i].model !== "ticket_id" &&
                                    AsterLeadFields[i].model !== "lead_id" &&
                                    AsterLeadFields[i].model !== "order_id" &&
                                    AsterLeadFields[i].model !== "list_id" &&
                                    AsterLeadFields[i].model !== "disposition" &&
                                    AsterLeadFields[i].model !== "hopper_status" &&
                                    AsterLeadFields[i].model !== "subdisposition" &&
                                    AsterLeadFields[i].model !== "deleted" &&
                                    AsterLeadFields[i].model !== "modified_by" &&
                                    AsterLeadFields[i].model !== "created_by" &&
                                    AsterLeadFields[i].model !== "created_at" &&
                                    AsterLeadFields[i].model !== "modified_date") {
                                    this.fields_model.push({ name: AsterLeadFields[i].model, value: AsterLeadFields[i].model, active: false })
                                }

                                if (AsterLeadFields[i].fieldType == "DatetimePicker") {
                                    this.fieldtype.DatetimePicker.push(AsterLeadFields[i].model)
                                } else if (AsterLeadFields[i].fieldType == "DatePicker") {
                                    this.fieldtype.DatePicker.push(AsterLeadFields[i].model)
                                }
                                if (AsterLeadFields[i].label === "Disposition") {
                                    let temp1 = JSON.parse(
                                        JSON.stringify(AsterLeadFields[i].values)
                                    );
                                    let temp2 = JSON.parse(temp1);
                                    for (let j = 0; temp2.length > j; ++j) {
                                        scope.bulk_dispo.push(temp2[j].name);
                                    }
                                }
                                AsterLeadFields[i].model = AsterLeadFields[i].model.replace(
                                    " ",
                                    "_"
                                );
                                AsterLeadFields[i].label = AsterLeadFields[i].label.replace(
                                    "_",
                                    " "
                                );
                                if (AsterLeadFields[i].show_on_view === true) {
                                    if (AsterLeadFields[i].model === "lead_id" || AsterLeadFields[i].model === "phone_number" || AsterLeadFields[i].model === "user" || AsterLeadFields[i].model === "disposition") {
                                        let key = {
                                            text: AsterLeadFields[i].label,
                                            value: AsterLeadFields[i].model,
                                            align: "center",
                                            sortable: false,
                                        };
                                        scope.headers.push(key);
                                    }
                                }

                                if (AsterLeadFields[i].filter === true) {

                                    if (AsterLeadFields[i].input_type === "Checkbox") {
                                        let filter1 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            input_type: AsterLeadFields[i].input_type,
                                        };
                                        checkboxes.push(filter1);
                                    }

                                    if (AsterLeadFields[i].input_type === "Radio") {
                                        let opt = JSON.parse(AsterLeadFields[i].values);
                                        let filter2 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            input_type: AsterLeadFields[i].input_type,
                                            options: opt,
                                        };
                                        radio.push(filter2);
                                    }

                                    if (AsterLeadFields[i].input_type === "DateTime") {
                                        let filter3 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            input_type: AsterLeadFields[i].input_type,
                                        };
                                        date_time.push(filter3);
                                    }
                                    if (AsterLeadFields[i].input_type === "Date") {
                                        let filter4 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            input_type: AsterLeadFields[i].input_type,
                                            is_active: true,
                                        };
                                        date.push(filter4);
                                    }
                                    if (AsterLeadFields[i].input_type === "text" && AsterLeadFields[i].model != 'user') {
                                        let filter5 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            input_type: AsterLeadFields[i].input_type,
                                        };

                                        text.push(filter5);


                                    }
                                    if (AsterLeadFields[i].input_type === "Select") {
                                        let options = JSON.parse(AsterLeadFields[i].values);
                                        let filter6 = {
                                            text: AsterLeadFields[i].label,
                                            value: "",
                                            model: AsterLeadFields[i].model,
                                            isMultiSelect: AsterLeadFields[i].multiple,
                                            input_type: AsterLeadFields[i].input_type,
                                            options: options,
                                        };

                                        select.push(filter6);
                                    }
                                    scope.agents = JSON.parse(localStorage.getItem("group_users"));
                                    this.agents.unshift("UNASSIGN");
                                    if (AsterLeadFields[i].model === 'user') {
                                        let filter6 = {
                                            text: "USER",
                                            value: "",
                                            model: "user",
                                            isMultiSelect: false,
                                            input_type: "Select",
                                            options: scope.agents,
                                        };
                                        select.push(filter6);
                                    }
                                }
                            }
                            this.dynamicFilterField.push(text);
                            this.dynamicFilterField.push(select);
                            this.dynamicFilterField.push(date);
                            this.dynamicFilterField.push(date_time);
                            this.dynamicFilterField.push(checkboxes);
                            this.dynamicFilterField.push(radio);

                        }
                        if (scope.GetAsterLead !== "") {
                            const payload = {
                                name: scope.GetAsterLead,
                                skip: scope.perPage * (scope.currentPage - 1),
                                take: scope.perPage,
                            };

                            scope.filtervalue = [];
                            scope.$store
                                .dispatch("GetAsterLeadData", payload)
                                .then((response) => {
                                    this.downloadData = response.downloadData;
                                    let datas = response.data;
                                    if (datas !== "" && datas !== undefined && datas !== null) {
                                        datas.forEach((element) => {
                                            scope.filtervalue.push(element["list_id"]);
                                        });
                                    }
                                    let temparr = [];
                                    datas.forEach((element) => {
                                        let tempobj = {};
                                        scope.headers.forEach((elm) => {
                                            if (
                                                element[elm.value] === undefined &&
                                                elm.value !== "actions"
                                            ) {
                                                tempobj[elm.value] = "";
                                            }
                                            if (
                                                elm.value !== "actions" &&
                                                element[elm.value] !== undefined
                                            ) {
                                                tempobj[elm.value] = element[elm.value];
                                            }
                                        });
                                        tempobj.checker = false;
                                        temparr.push(tempobj);

                                    });
                                    scope.AsterLeadValue = temparr;

                                    scope.AsterLeadValueClone = datas

                                    if (response.totalCount !== undefined) {
                                        scope.totalRows = response.totalCount;
                                    } else {
                                        scope.totalRows = 0;
                                    }
                                    scope.endPage = scope.currentPage * scope.perPage;
                                    scope.endPage =
                                        scope.endPage < scope.totalRows ?
                                            scope.endPage :
                                            scope.totalRows;
                                })
                                .catch(function (error) {
                                    scope.showSnackBar("error" + error);
                                });
                        }




                    })
                    .catch(function (error) {
                        scope.showSnackBar("error" + error);
                    });
            }
        },
        moveNextPage(next) {
            const scope = this;
            if (next && scope.totalRows >= scope.currentPage * scope.perPage + 1) {
                scope.currentPage = scope.currentPage + 1;
                scope.getDatafieldApi();
            } else if (!next && scope.currentPage !== 1) {
                scope.currentPage = scope.currentPage - 1;
                scope.getDatafieldApi();
            }
        },
        CloseItem() {
            let scope = this;
            scope.$router.push({
                name: "crm/AsterLead",
            });
        },
        UploadFile() {
            this.pagecontrol.isUploadFile = true;
        },
        ColseFile() {

            this.pagecontrol.isUploadFile = false;
            this.selected_list = "";
            this.uploadLead = getDefaultData();
            this.mapper = false
            this.csvheader = []
            for (let i = 0; i < this.fields_model.length; i++) {
                const element = this.fields_model[i];
                element.active = false

            }
            // this.$refs.createform.resetValidation();

        },
        isFilter() {
            this.pagecontrol.isFilterOpen = true;
        },
        next__: function () {
            if (this.csvheader.length > 0) {
                this.mapper = true
            }


        },

        filenext__: async function () {
            var files = await document.querySelector('#file').files;
            this.file = files[0]
            if (files.length > 0) {

                this.$store
                    .dispatch("Getfiledata", files[0])
                    .then((res) => {
                        for (let i = 0; i < res.length; i++) {
                            const element = res[i];
                            this.csvheader.push({
                                key: element,
                                value: ""
                            })

                        }


                    })
                    .catch(() => {

                    });
            } else {
                alert("Please select a file.");
            }


        },
        fetchFilter() {
            const scope = this;
            //var { page, rowsPerPage } = scope.pagination;
            console.log("scope.pagination",scope.pagination);
            let filterData = [];
            scope.dynamicFilterField.forEach((input_type) => {
                input_type.forEach((field) => {
                    if (field.value != "") {
                        filterData.push({ name: field.model, value: field.value });

                    }
                });
            });
            let filter = {
                template_name: scope.titleDatas,
                filterValues: filterData,
                skip: scope.perPage * (scope.currentPage - 1),
                take: scope.perPage,
                from_date: this.appliedfilter.fromdate,
                to_date: this.appliedfilter.todate,
            };

            scope.$store
                .dispatch("FilterAsterLeads", filter)
                .then((response) => {
                    let result = response.data;
                    scope.AsterLeadValue = [];
                    scope.select_check = false
                    if (result) {
                        for (let i = 0; i < result.length; i++) {
                            let element = {
                                "phone_number": result[i].phone_number,
                                "user": result[i].user,
                                "lead_id": result[i].lead_id,
                                "checker": false

                            }

                            scope.AsterLeadValue.push(element)
                            this.bulk_edit_arr = []

                        }
                    }


                    if (response.totalCount !== undefined) {
                        scope.totalRows = response.totalCount;
                    } else {
                        scope.totalRows = 0;
                    }
                    scope.endPage = scope.currentPage * scope.perPage;
                    scope.endPage =
                        scope.endPage < scope.totalRows ? scope.endPage : scope.totalRows;

                    this.isfilterval = true
                })
            // .catch(function (error) {
            // scope.showSnackBar("error" + error);
            // });
        },

        handleFileUpload: function () {
            var scope = this;
            scope.uploadLead.color = "#A64452";
            scope.uploadLead.label = "Uploading";
            let formData = new FormData();
            formData.append("file", scope.file);
            formData.append("template_name", scope.GetAsterLead);
            formData.append("list_id", scope.selected_list);
            // formData.append("user", JSON.parse(localStorage.apiInfo).user_email);
            // formData.append("hopper_status", "0");
            formData.append("created_by", JSON.parse(localStorage.apiInfo).user_email);
            formData.append("modified_by", JSON.parse(localStorage.apiInfo).user_email);
            formData.append("headerdata", JSON.stringify(scope.csvheader));
            formData.append("disposition", "new");
            console.log(formData, "ifhksfkjsdkjfnsdakdjfksddfkldslkkldskldsnk")
            api.defaults.headers["Content-Type"] = "multipart/form-data";
            api
                .post("/aster/fileupload", formData)
                .then((response) => {
                    api.defaults.headers["Content-Type"] = "application/json";
                    scope.getDatafieldApi();
                    if (response.data.dataCount > 0) {
                        scope.uploadLead.color = "#4BB543";
                        scope.uploadLead.label = "Uploaded Successfully";
                        scope.ColseFile();
                    } else {
                        scope.uploadLead.color = "#F51B00";
                        scope.uploadLead.label = "Invalid Field Format";
                    }
                    // scope.$refs.file.value = "";
                    if (response.data.skippedData.length > 0) {
                        if (response.data.filetype === 'csv') {
                            let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
                            let skipvalue = convertArrayToCSV(response.data.skippedData);
                            csvContent += skipvalue;
                            var encodedUri = encodeURI(csvContent);
                            var link = document.createElement("a");
                            link.setAttribute("href", encodedUri);
                            link.setAttribute("download", "skip" + scope.GetAsterLead + ".csv");
                            document.body.appendChild(link);
                            link.click();
                        } else {
                            let txtContent = "";
                            for (const key in response.data.skippedData[0]) {
                                let txt_tab = `${key} \t`;
                                txtContent += `${txt_tab}`;
                            }
                            response.data.skippedData.forEach(function (rows) {
                                let data = Object.values(rows);
                                let row = data.join("\t");
                                txtContent += `\n ${row}` + "\r";
                            });
                            var encodedUri1 =
                                "data:text/plain;charset=utf-8,\uFEFF" +
                                encodeURIComponent(txtContent);

                            var link1 = document.createElement("a");
                            link1.setAttribute("href", encodedUri1);
                            link1.setAttribute("download", "skip_" + `${this.template_name.templetname}.txt`);
                            document.body.appendChild(link1);
                            link1.click();
                        }
                        if (response.data.dataCount === 0) {
                            scope.ColseFile();
                        }
                    }

                    return response;
                })
                .catch((error) => {
                    console.log(error, "scope.$refs.file.clearAll")
                    api.defaults.headers["Content-Type"] = "application/json";
                    scope.uploadLead.color = "#F51B00";
                    scope.uploadLead.label = "Upload Error";
                    // scope.$refs.file.clearAll();
                    return error;
                });
        },
        assignAgent(leadData) {
            leadData = this.AsterLeadValueClone.find(elm => elm.lead_id == leadData.lead_id)
            const scope = this;
            scope.assignedDetails = JSON.parse(JSON.stringify(leadData));
            scope.assignedDetails.template_name = scope.GetAsterLead;
            scope.isShowAgentAssign = true;
            scope.$refs.refassign.resetValidation();
        },
        closeAssign() {
            const scope = this;
            scope.assignedDetails = {};
            scope.isShowAgentAssign = false;
            scope.$refs.refassign.resetValidation();
        },
        submitAssign() {
            const scope = this;
            const assignDetails = {
                lead_id: scope.assignedDetails["lead_id"],
                user: scope.assignedDetails["user"],
                template_name: scope.assignedDetails.template_name,
                modified_by: JSON.parse(localStorage.apiInfo).user_email
            };
            scope.$store
                .dispatch("AssignAgent", assignDetails)
                .then((response) => {
                    if (response.statusCode === 200) {
                        scope.showSnackBar("Lead assigned to agent successfully!");
                        scope.assignedDetails = {};
                        scope.isShowAgentAssign = false;
                        scope.$refs.refassign.resetValidation();
                        scope.getDatafieldApi();
                    } else {
                        scope.showSnackBar("Lead assigned to agent failed!");
                    }
                })
                .catch(() => {
                    scope.showSnackBar("Lead assigned to agent failed!");
                });
        },
        samplefiledownload(type) {
            const scope = this;
            let titleData = scope.GetAsterLead;
            let AsterLeadFields = "";
            scope.$store.dispatch("GetAsterLeadField", titleData).then((response) => {
                var datas = response.data[0].fields;
                AsterLeadFields = datas;
                const header = [];
                for (let i = 0; AsterLeadFields.length > i; ++i) {
                    let key = {
                        key: AsterLeadFields[i].model,
                        label: AsterLeadFields[i].label,
                    };

                    if (
                        AsterLeadFields[i].model !== "ticket_id" &&
                        AsterLeadFields[i].model !== "lead_id" &&
                        AsterLeadFields[i].model !== "order_id" &&
                        AsterLeadFields[i].model !== "list_id" &&
                        AsterLeadFields[i].model !== "disposition" &&
                        AsterLeadFields[i].model !== "hopper_status" &&
                        AsterLeadFields[i].model !== "subdisposition" &&
                        AsterLeadFields[i].model !== "deleted" &&
                        AsterLeadFields[i].model !== "modified_by" &&
                        AsterLeadFields[i].model !== "created_by" &&
                        AsterLeadFields[i].model !== "created_at" &&
                        AsterLeadFields[i].model !== "modified_date" &&
                        AsterLeadFields[i].model !== "isclosed"
                    ) {
                        header.push(AsterLeadFields[i].model);
                    }
                    scope.fielddata.push(key);
                }
                let csvContent = "";
                if (type === "csv") {
                    csvContent += "data:text/csv;charset=utf-8,\uFEFF";
                    csvContent += header.join(",");
                } else {
                    csvContent += "data:text/txt;charset=utf-8,\uFEFF";
                    csvContent += header.join("\t");
                }
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", titleData + "." + type);
                document.body.appendChild(link);
                link.click();
            });
        },
        refreshClick() {
            let scope = this;
            scope.getDatafieldApi();
        },
        pushBack() {
            this.$router.push({
                name: "crm/AsterLead",
            });
        },
        lead_info(val) {
            let obj = JSON.parse(localStorage.templetname);
            obj.lead_id = val
            localStorage.setItem("editfields", JSON.stringify(true));
            localStorage.setItem("templetname", JSON.stringify(obj));

            const titleData_local = JSON.parse(localStorage.getItem("templetname"));
            let titleData = titleData_local.templetname;
            this.$store.dispatch("GetAsterLeadField", titleData)
                .then(res => {
                    this.$store.dispatch('Editfields', res.data[0]);
                })
            this.$router.push({
                name: "crm/leadDetail",
            });
        }
    },
    mounted() {

        if (this.titleDatas !== "") {
            this.getDatafieldApi()
        }

        var scope = this;
        let stats = {
            list_name: "",
            list_campaign: "",
            list_status: "Y",
        };
        scope.$store.dispatch("FilterAsterList", stats).then((response) => {
            let data = response.data;
            let list = [];
            for (let i = 0; i < data.length; i++) {
                list.push(data[i].list_id);
            }
            scope.add_list = list;
        });
        scope.agents = JSON.parse(localStorage.getItem("group_users"));
        setTimeout(
            function () {
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:fileupload"
                    ) !== -1
                ) {
                    scope.pagecontrol.fileupload = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:userassign"
                    ) !== -1
                ) {
                    scope.pagecontrol.userassign = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:edit"
                    ) !== -1
                ) {
                    scope.pagecontrol.canedit = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:create"
                    ) !== -1
                ) {
                    scope.pagecontrol.cancreate = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:delete"
                    ) !== -1
                ) {
                    scope.pagecontrol.candelete = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "leadmanagement:lead:download"
                    ) !== -1
                ) {
                    scope.pagecontrol.export = true;
                }
            }.bind(scope),
            1
        );

        this.uploadLead = getDefaultData();
    },
};
</script>
   
<style>
.btn-light {
    margin-left: 900px;
}

.edit-icon {
    margin: 0px 10px !important;
    color: blue;
}

.delete-icon {
    margin: 0px 10px !important;
    color: red;
}

.mr-3 {
    padding: 10px !important;
    margin: 10px !important;
    margin-top: -7px !important;
    color: #2196f3 !important;
    position: absolute;
    top: 87px;
    right: 45px;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-weight: 400 !important;
    font-size: 13px !important;
    font-family: "Lato", sans-serif;
}

.mr-6 {
    padding: 10px !important;
    margin: 50px !important;
    margin-top: -7px !important;
    color: #2196f3 !important;
    position: absolute;
    top: 87px;
    right: 90px;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-weight: 400 !important;
    font-size: 13px !important;
    font-family: "Lato", sans-serif;
}



/* .csvBtn{
    height: 50px;
    width: 230px;
    background-color: green;
    }
    .textBtn{
    height: 50px;
    width: 230px;
    background-color: palevioletred;
    } */
.title {
    padding: 10px !important;
    margin: 10px;
    color: #2196f3 !important;
}

.b-table-sticky-header {
    overflow-y: auto !important;
    overflow-x: auto !important;
    max-height: 390px !important;
}

.tabledata {
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.1);
}

.tabledata tr th {
    background: #fff;
    font-weight: 400 !important;
    font-size: 13px !important;
    color: rgba(0, 0, 0, 0.54);
    font-family: "Lato", sans-serif;
    padding: 15px 10px !important;
}

.tabledata tr td {
    background: #fff;
    font-weight: 400 !important;
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.87);
    font-family: "Lato", sans-serif;
    padding: 15px !important;
}

.b-table-sticky-header,
.table-responsive,
[class*="table-responsive-"] {
    margin-bottom: 0rem !important;
}

.showing_history {
    padding: 5px;
    padding-top: 10px;
}

.showing_history .icon_history {
    font-size: 40px;
    padding-bottom: 0px;
    padding-top: 20px;
    margin-bottom: -16px;
    padding: 10px;
    height: 20px;
}

.pagination-div {
    background: #fff;
    height: 60px;
    margin-top: 5px;
    width: 100%;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.2) !important;
    border-bottom-color: #ccc;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px;
    -ms-flex-wrap: wrap-reverse;
    flex-wrap: wrap-reverse;
}

.pagination-div #row-selector {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px !important;
    color: rgba(53, 18, 18, 0.54) !important;
    font-family: "Lato", sans-serif !important;
    -ms-flex-wrap: wrap-reverse;
    flex-wrap: wrap-reverse;
}

.pagination-div #row-selector select {
    margin-left: 10px;
    font-size: 13px !important;
    color: rgba(0, 0, 0, 0.87) !important;
    font-family: "Lato", sans-serif !important;
}

.pagination-div #row-selector #page-control {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px !important;
    color: rgba(53, 18, 18, 0.54) !important;
    font-family: "Lato", sans-serif !important;
    -ms-flex-wrap: wrap-reverse;
    flex-wrap: wrap-reverse;
}

.pagination-div #row-selector #page-control .action-icon {
    color: rgba(53, 18, 18, 0.64) !important;
    margin-left: 20px;
}

.pagination-div #row-selector #page-control .action-icon .move-page {
    margin: auto 20px;
    cursor: pointer !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

.toolbar_operations {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 150px;
    top: 41px;
    right: 55px;
}

.toolbar_operations .v-icon {
    color: #2196f3 !important;
}

.icon_section {
    align-content: center;
    padding: 0px 0px 0px 70px;
}

.exportflex {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 20px;

}

.export {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    height: 130px;
    text-align: center;
    padding: 20px;
    background-color: #cacaca;
    color: #ffffff;
    border-radius: 10px;
}


.hovericon {
    color: #2C3E50;
    cursor: pointer;
}


.pop_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}

.fa-filter12:before {
    /* border: 1px solid; */
    width: 33px;
    height: 33px;
    padding: 9px;
    border-radius: 50px;
    content: "\f0b0";
}

.fa-filter12:hover {
    /* border: 1px solid; */
    border-radius: 50px;
    color: #fff;
    background-color: #b3d4fc;
    opacity: 0.12px;
}

.fa-refresh1:before {
    width: 33px;
    height: 33px;
    padding: 9px;
    border-radius: 50px;
}

.fa-refresh1:hover {
    border-radius: 50px;
    color: #fff;
    background-color: #b3d4fc;
    opacity: 1px;
}

.fa-upload:before {
    width: 33px;
    height: 33px;
    padding: 9px;
    border-radius: 50px;
    content: "\f093";
}

.fa-upload:hover {
    /* border: 1px solid; */
    border-radius: 50px;
    color: #fff;
    background-color: #b3d4fc;
    opacity: 1px;
}

.fa-download1:before {
    content: "\f019";
    width: 33px;
    height: 33px;
    padding: 9px;
    border-radius: 50px;

}

.fa-download1:hover {
    /* border: 1px solid; */
    border-radius: 50px;
    color: #fff;
    background-color: #b3d4fc;
    opacity: 1px;
}

.fa-plus1:before {
    content: "\f067";
    width: 33px;
    height: 33px;
    padding: 9px;
    border-radius: 50px;

}

.fa-plus1:hover {
    /* border: 1px solid; */
    border-radius: 50px;
    color: #fff;
    background-color: #b3d4fc;
}

.fa-pencil-square-o:before {
    width: 30px;
    height: 15px;
}

.nextbutton {
    display: flex;
    flex-direction: row;
    justify-content: end;

}

.nextbutton-innerdiv {
    width: 60px;
    font-weight: 700;
    padding: 7px;
    text-align: center;
    background-color: #2296f3;
    color: #fff;
    border-radius: 5px;
}

.map_value {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;

}

.map_value_lft {
    width: 150px;
    margin: auto;
    margin-left: 5px;
    font-weight: 700;
}

.map_value_rht {

    width: calc(100% - 150px);
}
</style>